/**
 * Responsive sources for the site's photography.
 *
 * This is a real gap being closed, not a nicety. Every header image was being
 * served at a single fixed width — a phone on mobile data was pulling a
 * 2400px-wide JPEG to paint a 375px-wide box, several times over per page. The
 * fix is to publish each picture at a ladder of widths and let the browser
 * choose using the `sizes` hint each caller supplies.
 *
 * The Pexels helpers that used to live here are gone: every photograph on the
 * site is now IWM's own, so there is nothing left to fetch from a third party.
 */
const WIDTHS = [640, 960, 1280, 1600, 2000, 2400];

/**
 * IWM's own photography, served from public/ at the width ladder above.
 * `local("iwm-crab")` yields the src/srcSet pair for that set.
 */
export function local(name, fallbackWidth = 1600) {
  return {
    src: `/${name}-${fallbackWidth}.jpg`,
    srcSet: WIDTHS.map((w) => `/${name}-${w}.jpg ${w}w`).join(", "),
  };
}

export default { local };
